import { render, staticRenderFns } from "./FoodDetail.vue?vue&type=template&id=5cc62f20&scoped=true"
import script from "./FoodDetail.vue?vue&type=script&lang=ts"
export * from "./FoodDetail.vue?vue&type=script&lang=ts"
import style0 from "./FoodDetail.vue?vue&type=style&index=0&id=5cc62f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc62f20",
  null
  
)

export default component.exports